module.exports = __webpack_public_path__ + "img/05_Constant Learner.7c572dbc.svg";